<template>
  <div v-loading="loading" class="yxtbiz-attend-leave-audit">
    <yxt-row class="yxtbiz-attend-leave-audit__row" align="middle" type="flex">
      <div class="color-gray-7 yxtbiz-attend-leave-audit__name">{{$t('pc_biz_attend_name' /* 考勤名称 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
      <div class="yxtbiz-attend-leave-audit__value color-gray-10">{{attendName}}</div>
    </yxt-row>
    <yxt-row class="yxtbiz-attend-leave-audit__row" align="middle" type="flex">
      <div class="color-gray-7 yxtbiz-attend-leave-audit__name">{{$t('pc_biz_leave_reason' /* 请假原因 */) + $t('pc_biz_enroll_lbl_colon' /* : */)}}</div>
      <div class="yxtbiz-attend-leave-audit__value color-gray-10">{{leaveReason ? leaveReason : '--'}}</div>
    </yxt-row >
    <yxt-image
      v-if="attachments && attachments.length > 0"
      class="yxtbiz-attend-leave-audit__image"
      :src="attachments[0].url"
      :preview-src-list="[attachments[0].url]"
    />
  </div>
</template>

<script>
import {getLeaveAuditInfo} from './service';

export default {
  name: 'YxtbizAttendLeaveAudit',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      attendName: '',
      leaveReason: '',
      attachments: []
    };
  },
  mounted() {
    this.fetchLeaveAuditInfo();
  },
  methods: {
    fetchLeaveAuditInfo() {
      this.loading = true;
      getLeaveAuditInfo(this.id)
        .then(res => {
          const {attachments, attendName, leaveReason} = res || {};
          Object.assign(this, {attachments, attendName, leaveReason});
        })
        .finally(() =>(this.loading = false));
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-attend-leave-audit {
  &__row:not(:first-of-type) {
    margin-top: 24px;
  }

  &__name {
    line-height: 22px;
    font-size: 14px;    
  }

  &__label {
    line-height: 22px;
    font-size: 14px;
  }

  &__image {
    margin-top: 10px;
    width: 120px;
    height: 120px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
}
</style>